import React from 'react'
import Main from './Main'
import Layout from '../common/Layout';
import reportService from '../../services/reportService';

export default () => {
    return <Layout>
        <Main reportService={reportService}/>
    </Layout>
};